import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { PackersMoversService } from "../service/packers-movers.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
@Component({
  selector: "app-view-packers-movers",
  templateUrl: "./view-packers-movers.component.html",
  styleUrls: ["./view-packers-movers.component.sass"],
})
export class ViewPackersMoversComponent implements OnInit {
  id: string = "";
  packersMoversDetails: any = {};

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private packersMoversService: PackersMoversService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.id = params["id"];

      if (this.id) {
        this.getPackersMoversById();
      }
    });
  }

  getPackersMoversById() {
    this.packersMoversService.getPackersMoversById(this.id).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.packersMoversDetails = response.data;
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  goBack() {
    this.router.navigate(["/dashboard/website-packers-movers-requests"]);
  }

  getFurnitureItems() {
    return this.getItemsWithQty(this.packersMoversDetails?.furnitureData);
  }

  getAppliancesItems() {
    return this.getItemsWithQty(this.packersMoversDetails?.appliancesData);
  }

  getCartonsItems() {
    return this.getItemsWithQty(this.packersMoversDetails?.cartonsData);
  }

  getItemsWithQty(data: any): any[] {
    if (!data) {
      return [];
    }

    const result: any[] = [];

    Object.keys(data).forEach((category) => {
      data[category].forEach((item: { qty: number; name: string }) => {
        if (item.qty > 0) {
          result.push({
            category,
            name: item.name,
            qty: item.qty,
          });
        }
      });
    });

    return result;
  }
  getYoutubeEmbedUrl(url: string) {
    let videoId = "";

    if (url.includes("youtu.be/")) {
      videoId = url.split("youtu.be/")[1].split("?")[0];
    } else if (url.includes("/shorts/")) {
      videoId = url.split("/shorts/")[1].split("?")[0];
    } else if (url.includes("watch?v=")) {
      videoId = url.split("watch?v=")[1].split("&")[0];
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${videoId}`,
    );
  }
}
